export default __webpack_public_path__ + "static/media/img_base_grey_p.8aaedffe.jpg";